import { useCallback, useEffect, useState } from "react";

const useHiddenWithMount = (initialHidden: boolean, initialMounted?: boolean, delay?: number) => {

    const [mounted, setMounted] = useState(initialMounted ?? false);
    const [hidden, setHidden] = useState(initialHidden ?? true);

    const setWithDelay = useCallback((hidden: boolean) => {
        if (!initialMounted && !hidden) {
            setMounted(true);
        }

        setTimeout(() => {
            setHidden(hidden)
        }, 100);
    }, []);

    return [hidden, setWithDelay, mounted] as [typeof hidden, typeof setWithDelay, typeof initialMounted];

};


export default useHiddenWithMount;